import { ApprovalDecisionActions } from '../../_components/Shared/ApprovalDecisionActions';
import { getApprovalCapabilities, isFinalApprovalDecision } from '../../_services/approval.service';
import { apiFetch } from "../../_services/apiFetch";
import React from 'react';
import { Button } from 'react-bootstrap';
import { Link, useParams, useNavigate } from 'react-router-dom';
import config from '../../../config';
import utils from '../../utils';
import moment from 'moment';
import QValuePageHeader from '../../_components/QValuePageHeader';
import { getQValueReportHeader } from '../../utils/qValuePageHeaders';

class OutgoingSummaryReport extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            employeeID: '',
            executionNo: '',
            workOrder: '',
            isPendingForMe: false,
            isApproved: false,
            isRejected: false,
            approvalCapabilities: null,
            newLine: '<tr><th colspan="34">&nbsp;</th></tr>',
            tableStyle: '<meta content="text/html; charset=UTF-8" http-equiv="Content-Type"><meta content="IE=8" http-equiv="X-UA-Compatible"><title>bcl_667529169.htm</title><meta content="BCL easyConverter SDK 5.0.08" name="generator"><style> th, td {width:auto, overflow:hidden;word-wrap:break-word;text-align: center;font-size: 10pt; border: 1px solid black; }table{max-width:2490px;width:100%;background-color:white; border-collapse: collapse;}.left{padding:5px; text-align:left}.vertical-text{position: relative;height: 300px;width: 45px;margin-left: 0;padding-right: 10px;writing-mode: tb-rl;-webkit-transform: rotate(180deg);filter: flipv fliph;}.short{height:80px}</style>',
            tableHeader: '<table id="outgoingreport" border=1; cellspacing=0/>'
                + '<tr><th colspan="34">Outgoing Inspection Report</th></tr>'
                + '<tr><th colspan="6" class="left" style = "">Report No: </th></tr>'
                + '<tr><th colspan="34" class="left" style = "">Reported By: </th></tr>'
                + '<tr><th colspan="6" class="left" style = "">Job No: </th><th colspan="6" class="left" style = "">Job Qty: </th><th colspan="23" class="left" style = "">Process Date: </th></tr>'
                + '<tr><th colspan="34" class="left" style = "">Master Job No: </th></tr>'
                + '<tr><th colspan="34" class="left" style = "">Customer Part No: </th></tr>'
                + '<tr><th colspan="2" class="left" style = "">Part No: </th>'
                + '<th class="left" colspan="4" style = "">Customer: </th>'
                + '<th class="left" colspan="5" style = "">Model: </th>'
                + '<th class="left" colspan="2" style = "">AQL: </th>'
                + '<th class="left" colspan="2" style = "">Station: </th>'
                + '<th class="left" colspan="2" style = "">Defect Qty: </th>'
                + '<th class="left" colspan="23" style = "">Defect Rate: </th>'
                + '</tr>'
                + '<tr><th colspan="34">&nbsp;</th></tr>'
                + '<tr><th colspan="34">&nbsp;</th></tr>',
            inspectionHeader: '<tr><th class="left" style = "">Inspection Requirement </th>'
                + '<th class="left" style = "">Specification</th>'
                + '<th class="left" style = "">Content</th>'
                + '<th class="left" style = "">Description</th>'
                + '<th class="left" style = "">Result 1</th>'
                + '<th class="left" style = "">Result 2</th>'
                + '</tr>',
            testHeader: '<tr><th class="left" style = "">Test Requirement </th>'
                + '<th class="left" style = "">Equipment</th>'
                + '<th class="left" style = "">Specification</th>'
                + '<th class="left" style = "">No of Point</th>'
                + '<th class="left" style = "">Upper Limit</th>'
                + '<th class="left" style = "">Lower Limit</th>'
                + '<th class="left" style = "">Description</th>'
                + '<th class="left" style = "">Result 1</th>'
                + '<th class="left" style = "">Result 2</th>'
                + '</tr>',
            measuringHeader: '<tr><th colspan="34" class="left" style = "">Measuring Requirement </th><tr>'
                + '<tr><th class="left" style = "">Point To Measure</th>'
                + '<th class="left" style = "">Equipment</th>'
                + '<th class="left" style = "">Dimension</th>'
                + '<th class="left" style = "">UCL</th>'
                + '<th class="left" style = "">LCL</th>'
                + '<th class="left" style = "">CMK</th>'
                + '<th class="left" style = "">CPK</th>'
                + '<th class="left" style = "">Result 1</th>'
                + '<th class="left" style = "">Result 2</th>'
                + '<th class="left" style = "">Result 3</th>'
                + '<th class="left" style = "">Result 4</th>'
                + '<th class="left" style = "">Result 5</th>'
                + '</tr>',
            tableFooter: '<tr><th class="left" colspan="34">Remarks: </th></tr>'
                + '<tr><th class="left" colspan="34">Checked By: </th></tr>'
                + '<tr><th class="left" colspan="34">Approved By: </th></tr>'


        };
        this.handleChange = this.handleChange.bind(this);

    }


    componentDidMount() {
        this.buildHtmlTable();
        this.fetchApprovalStatus();
    }

    fetchApprovalStatus() {
        const { id } = this.props.params || {};
        if (!id) return;

        const userData = localStorage.getItem('user');
        if (!userData) return;

        let user;
        try {
            user = JSON.parse(userData);
        } catch (e) {
            return;
        }

        const userId = user ? (typeof user.id === 'number' ? user.id : parseInt(user.id, 10)) : null;
        if (!userId || isNaN(userId)) return;

        const recordId = typeof id === 'number' ? id : parseInt(id, 10);

        return getApprovalCapabilities('outgoing', recordId)
            .then(capabilities => this.setState({
                approvalCapabilities: capabilities,
                isPendingForMe: capabilities.canApprove === true || capabilities.canReject === true,
            }))
            .catch(error => {
                console.error('Error fetching approval status:', error);
                this.setState({ isPendingForMe: false, approvalCapabilities: null });
            });
    }

    handleApprovalDecision = async (result, { action }) => {
        window.alert(action === 'reject'
            ? 'Record rejected.'
            : isFinalApprovalDecision(result)
                ? 'Approved successfully.'
                : 'Approval recorded. Pending the next approval level.');

        if (this.props.navigate) {
            this.props.navigate('/outgoing_summary');
            return;
        }

        await this.fetchApprovalStatus();
        await this.buildHtmlTable();
    }

    buildHtmlTable() {
        const { id } = this.props.params || {};
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ machine: this.state.selectedMachine, start: this.state.selectedStart, end: this.state.selectedEnd, executionNo: this.state.executionNo, employeeID: this.state.employeeID, workOrder: this.state.workOrder })
        };

        if (localStorage.getItem('user') != null) {
            this.setState({ approvedBy: JSON.parse(localStorage.getItem('user')).username });
            return fetch(`${config.apiUrl}/getOutgoingData?id=${id}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return fetch(`${config.apiUrl}/getUserByID?id=${data.updated_by}`, requestOptions).then(response => response.text().then(text => {
                            data.updated_by = text && JSON.parse(text).username;

                            return data;
                        })).catch(error => {
                            console.error('Error fetching user by ID:', error);
                            return data;
                        });
                    });
                })
                .then(body => {
                    body.reportNo = moment(body.Timestamp).format('YYYYMMDD') + '3' + body.id;
                    // Ensure master object exists to prevent errors
                    if (!body.master) {
                        body.master = {};
                    }

                    // Update approval status from the fetched record data
                    const isApproved = body.approve_status === 1 || body.approve_status === '1';
                    const isRejected = body.approve_status === 2 || body.approve_status === '2';
                    if (isApproved) {
                        this.setState({ isApproved: true, isPendingForMe: false });
                    } else if (isRejected) {
                        this.setState({ isRejected: true, isPendingForMe: false });
                    }

                    // approved_by will come from API when approve_status=1
                    // Set state and use callback to ensure state is updated before proceeding
                    this.setState(body, () => {
                        // State is now updated, continue with rendering
                        this.renderTable(body);
                    });
                    return body;
                })
                .then(body => {
                    // This will execute after setState callback
                    return body;
                });

        }
    }

    renderTable(body) {
        const { tableStyle, tableHeader, tableFooter, inspectionHeader, testHeader, measuringHeader } = this.state;
        // login successful if there's a user in the response
        let html = '';
        // Ensure arrays exist before checking length
        if (body.inspections && Array.isArray(body.inspections) && body.inspections.length) {
            html += inspectionHeader;
            body.inspections.map(item => {
                if (item.INSPECTION_REQUIREMENT) {
                    html += '<tr>';
                    html += this.tdWrap(item.INSPECTION_REQUIREMENT.requirement);
                    html += this.tdWrap(item.INSPECTION_REQUIREMENT.specification);
                    html += this.tdWrap(item.INSPECTION_REQUIREMENT.content);
                    html += this.tdWrap(item.INSPECTION_REQUIREMENT.remark);
                    html += this.tdWrap(item.result1);
                    html += this.tdWrap(item.result2);
                    html += '</tr>';
                }
            });
            html += this.state.newLine;

        }
        if (body.tests && Array.isArray(body.tests) && body.tests.length) {
            html += testHeader;
            body.tests.map(item => {
                if (item.TEST_REQUIREMENT) {
                    html += '<tr>';
                    html += this.tdWrap(item.TEST_REQUIREMENT.requirement);
                    html += this.tdWrap(item.TEST_REQUIREMENT.equipment);
                    html += this.tdWrap(item.TEST_REQUIREMENT.specification);
                    html += this.tdWrap(item.TEST_REQUIREMENT.noOfPoint);
                    html += this.tdWrap(item.TEST_REQUIREMENT.upperLimit);
                    html += this.tdWrap(item.TEST_REQUIREMENT.lowerLimit);
                    html += this.tdWrap(item.TEST_REQUIREMENT.remark);
                    html += this.tdWrap(item.result1);
                    html += this.tdWrap(item.result2);
                    html += '</tr>';
                }

            });
            html += this.state.newLine;

        }
        if (body.measurings && Array.isArray(body.measurings) && body.measurings.length) {
            html += measuringHeader;
            body.measurings.sort((a, b) => a.MEASURING_REQUIREMENT.pointToMeasure > b.MEASURING_REQUIREMENT.pointToMeasure ? 1 : -1).map(item => {
                if (item.MEASURING_REQUIREMENT) {
                    html += '<tr>';
                    html += this.tdWrap(item.MEASURING_REQUIREMENT.pointToMeasure);
                    html += this.tdWrap(item.MEASURING_REQUIREMENT.equipment);
                    html += this.tdWrap(item.MEASURING_REQUIREMENT.Dimension);
                    html += this.tdWrap(item.MEASURING_REQUIREMENT.UCL);
                    html += this.tdWrap(item.MEASURING_REQUIREMENT.LCL);
                    html += this.tdWrap(item.MEASURING_REQUIREMENT.CMK);
                    html += this.tdWrap(item.MEASURING_REQUIREMENT.CPK);
                    html += this.tdWrap(item.result1, item);
                    html += this.tdWrap(item.result2, item);
                    html += this.tdWrap(item.result3, item);
                    html += this.tdWrap(item.result4, item);
                    html += this.tdWrap(item.result5, item);
                    html += '</tr>';
                }
            });
            html += this.state.newLine;

        }

        if (body.files && Array.isArray(body.files) && body.files.length) {
            let imglist = '';
            body.files.map(item => {
                imglist += '<img id="img' + item.id + '" width="300" style="margin:2px;padding:2px;border: 1px solid #ddd" />'
            });
            html += '<tr>';
            html += '<td colspan="34" style="text-align:left">' + imglist + '</td>';
            html += '</tr>';
            html += this.state.newLine;
        }
        let safeHTML = utils.sanitizeVoidTags((tableStyle + this.fillInDetails(tableHeader, body) + html.split('undefined').join('') + this.fillInDetails(tableFooter, body))
            .replaceAll('</img>', '')
            .replaceAll('</input>', '')
            .replaceAll('</br>', '<br/>')
            .replaceAll('</hr>', '<hr/>'));
        this.setState({ table: safeHTML }, () => {
            // Wait for DOM to update before encoding images
            if (body.files && Array.isArray(body.files) && body.files.length) {
                // Use setTimeout to ensure DOM is fully rendered
                setTimeout(() => {
                    body.files.map(item => {
                        this.encodeImage(item, dataurl => {
                            let img = document.getElementById("img" + item.id);
                            if (img) {
                                img.src = dataurl;
                            }
                        });
                    });
                }, 100);
            }
        });
    }

    encodeImage(item, callback) {
        var canvas = document.createElement('canvas'),
            ctx = canvas.getContext('2d'),
            img = new Image(); // Use a new Image object to load the image

        img.crossOrigin = 'anonymous'; // Handle CORS if needed
        img.onload = () => {
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0, img.width, img.height);
            callback(canvas.toDataURL());
        }
        img.onerror = () => {
            console.warn('Failed to load image:', item.imgPath);
        }
        img.src = item.imgPath;
    }

    fillInDetails(tableHeader, body = null) {
        // Use body data if provided, otherwise fall back to state
        const data = body || this.state;
        const master = data.master || {};
        const reportNo = data.reportNo || '';
        const jobNo = data.jobNo || '';
        const jobQty = data.jobQty || '';
        const customerPartNo = master.customerPartNo || data.customerPartNo || '';
        const timestamp = data.Timestamp ? (new Date(data.Timestamp)).toLocaleString() : '';
        const defectQty = data.defectQty || '';
        const lotQty = data.lotQty || '';
        const defectRate = (defectQty && lotQty) ? (Number(defectQty) / Number(lotQty) * 100).toFixed(5) : '0.00000';
        const createdBy = data.created_by || '';
        const createdAt = (data.createdAt || data.created_at) ? ', ' + moment(data.createdAt || data.created_at).format('YYYY-MM-DD HH:mm:SS') : '';
        const updatedBy = data.updated_by || '';
        const updatedAt = (data.updatedAt || data.updated_at) ? ', ' + moment(data.updatedAt || data.updated_at).format('YYYY-MM-DD HH:mm:SS') : '';
        const remark = data.remark || '';

        tableHeader = tableHeader.split('Report No: ').join('Report No: ' + reportNo);
        tableHeader = tableHeader.split('Reported By: ').join('Reported By: ' + createdBy);
        tableHeader = tableHeader.split('Master Job No: ').join('Master Job No: ' + (data.masterJobNo || ''));
        tableHeader = tableHeader.split('Customer Part No: ').join('Customer Part No: ' + customerPartNo);
        // By using '>Job No: ' as the delimiter (with > from the HTML tag), 
        // it only matches <th...>Job No: </th> and cannot match inside <th...>Master Job No: </th>
        tableHeader = tableHeader.split('>Job No: ').join('>Job No: ' + jobNo);
        tableHeader = tableHeader.split('Job Qty: ').join('Job Qty: ' + jobQty);
        tableHeader = tableHeader.split('Process Date: ').join('Process Date: ' + timestamp);
        tableHeader = tableHeader.split('>Part No: ').join('>Part No: ' + (master.partNo || ''));
        tableHeader = tableHeader.split('Description: ').join('Description: ' + (master.partDesc || ''));
        tableHeader = tableHeader.split('Customer: ').join('Customer: ' + (master.customer || ''));
        tableHeader = tableHeader.split('Model: ').join('Model: ' + (master.model || ''));
        tableHeader = tableHeader.split('AQL: ').join('AQL: ' + (master.AQL || ''));
        tableHeader = tableHeader.split('Defect Qty: ').join('Defect Qty: ' + defectQty);
        tableHeader = tableHeader.split('Defect Rate: ').join('Defect Rate: ' + defectRate + '%');
        tableHeader = tableHeader.split('Checked By: ').join('Checked By: ' + createdBy + createdAt);
        // Only show "Approved By:" row if updatedBy has a value
        if (updatedBy && updatedBy.trim() !== '') {
            tableHeader = tableHeader.split('Approved By: ').join('Approved By: ' + updatedBy + updatedAt);
        } else {
            // Remove the "Approved By:" row if no value
            tableHeader = tableHeader.replace(/<tr><th class="left" colspan="34">Approved By: <\/th><\/tr>\s*/g, '');
        }
        tableHeader = tableHeader.split('Remarks: ').join('Remarks: ' + remark);
        return tableHeader;
    }

    exportExcel() {
        const master = this.state.master || {};
        const partNo = master.partNo || 'unknown';
        const timestamp = this.state.Timestamp ? (new Date(this.state.Timestamp)).toLocaleString() : new Date().toLocaleString();
        utils.tableToExcel('datatable', 'Report', 'Outgoing_report_' + partNo + '_' + timestamp + '.xls');
    };

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    render() {
        const { tableStyle, tableHeader, tableContent, executionNo, employeeID, workOrder, isPendingForMe, isApproved, isRejected } = this.state;
        return (
            <div class="container">
                <QValuePageHeader
                    {...getQValueReportHeader('outgoing_summary', {
                        readOnly: this.props.readOnly,
                        executionNo,
                        workOrder,
                    })}
                />
                <div style={{ marginBbottom: '20em', position: 'relative', minHeight: '50px' }}>
                    {this.state.table ? <div style={{ width: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
                        {!this.props.readOnly && <Link
                            to="/outgoing_summary"
                            className="btn btn-outline-secondary"
                            style={{ marginRight: 'auto' }}
                        >Back</Link>}
                        {isPendingForMe && !isApproved && !isRejected && (
                            <ApprovalDecisionActions
                                recordType="outgoing"
                                recordId={Number(this.props.params?.id)}
                                currentLevel={this.state.approvalCapabilities?.currentLevel}
                                canApprove={this.state.approvalCapabilities?.canApprove === true}
                                canReject={this.state.approvalCapabilities?.canReject === true}
                                onDecision={this.handleApprovalDecision}
                            />
                        )}
                        {isApproved && (
                            <span style={{ color: 'green', fontWeight: 'bold', fontSize: '14px' }}>APPROVED</span>
                        )}
                        {isRejected && (
                            <span style={{ color: 'red', fontWeight: 'bold', fontSize: '14px' }}>REJECTED</span>
                        )}
                        <Button
                            bsStyle="primary"
                            style={{ margin: 0 }}
                            onClick={e => this.exportExcel()}>Export</Button>
                    </div> : ''}
                    <a id='dlink' style={{ display: 'none' }}></a>
                </div>
                <div id="datatable" class="container" style={{ overflowY: 'auto' }} dangerouslySetInnerHTML={{ __html: this.state.table }} />
            </div>
        );
    }
}

// HOC to inject useParams and useNavigate hooks into class component
function withParams(Component) {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        return <Component {...props} params={params} navigate={navigate} />;
    };
}

const OutgoingSummaryReportWithParams = withParams(OutgoingSummaryReport);
export { OutgoingSummaryReportWithParams as OutgoingSummaryReport };
